export const normalizedPointFromImage = (clientX, clientY, image) => {
  const bounds = image?.getBoundingClientRect?.();
  if (!bounds?.width || !bounds?.height) return null;
  return {
    x: Math.max(0, Math.min(1, (clientX - bounds.left) / bounds.width)),
    y: Math.max(0, Math.min(1, (clientY - bounds.top) / bounds.height)),
  };
};

export const buildVisualTemplateFromImage = (image, selection, threshold = 0.86) => {
  if (!image?.naturalWidth || !image?.naturalHeight || !selection) {
    throw new Error('The captured screenshot has not finished loading.');
  }
  const sourceX = Math.round(selection.x * image.naturalWidth);
  const sourceY = Math.round(selection.y * image.naturalHeight);
  const sourceWidth = Math.max(1, Math.round(selection.width * image.naturalWidth));
  const sourceHeight = Math.max(1, Math.round(selection.height * image.naturalHeight));
  const scale = Math.min(1, 320 / sourceWidth, 180 / sourceHeight);
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(sourceWidth * scale));
  canvas.height = Math.max(1, Math.round(sourceHeight * scale));
  canvas.getContext('2d').drawImage(
    image,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    0,
    0,
    canvas.width,
    canvas.height
  );
  return {
    region: selection,
    threshold: Number(threshold),
    templateDataUrl: canvas.toDataURL('image/jpeg', 0.82),
  };
};
